var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hide": _vm.onHide
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('h2', {
    staticClass: "h2 heading mb-0"
  }, [_vm._v(" Confirm patient transfer ")])]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-alert', {
    attrs: {
      "variant": "warning"
    },
    model: {
      value: _vm.alert.show,
      callback: function ($$v) {
        _vm.$set(_vm.alert, "show", $$v);
      },
      expression: "alert.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" You are about to reassign " + _vm._s(_vm.totalToTransfer) + " patients from " + _vm._s(_vm.sourceDoctorLabel) + ". ")]), _c('b-alert', {
    staticClass: "tw-flex tw-items-start tw-gap-2",
    attrs: {
      "show": _vm.isTemporary,
      "variant": "warning"
    }
  }, [_c('b-icon', {
    staticClass: "tw-mt-0.5 tw-shrink-0",
    attrs: {
      "icon": "exclamation-triangle"
    }
  }), _c('span', [_vm._v(" Patients will be temporarily reassigned from " + _vm._s(_vm.formattedStart) + " through " + _vm._s(_vm.formattedEnd) + ", then automatically returned to their original doctor. ")])], 1), _c('div', {
    staticClass: "tw-mt-3 tw-rounded tw-border tw-border-gray-200 tw-p-4"
  }, [_c('b-row', {
    staticClass: "tw-mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Reassignment type")]), _c('div', [_vm._v(_vm._s(_vm.isTemporary ? 'Temporary' : 'Permanent'))])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Effective window")]), _c('div', [_vm._v(_vm._s(_vm.effectiveWindowLabel))])])], 1), _c('b-row', {
    staticClass: "tw-mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Request reason")]), _c('div', [_vm._v(_vm._s(_vm.reasonLabel || '—'))])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("States affected")]), _c('div', [_vm._v(_vm._s(_vm.statesCount))])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Receiving doctors")]), _c('div', [_vm._v(_vm._s(_vm.doctorsCount))])])], 1)], 1), _c('b-row', {
    staticClass: "tw-mt-5"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.submitting,
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "disabled": _vm.submitting,
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.confirmTransfer
    }
  }, [_vm.submitting ? _c('span', [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Transferring... ")], 1) : _c('span', [_vm._v("Yes, Transfer")])])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };